import React, { useState } from 'react';
import { ModalPortal, useCloseOnEsc, useTrapFocus } from '@weahead/react-customizable-modal';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import Image from 'next/image';

import { Icon } from 'components/tokens/Icon';
import { close } from 'icons/default';
import { Colors } from 'enums/Colors';

import '@splidejs/react-splide/css/core';
import styles from './LightBox.module.scss';

interface ILightBox {
  images: Array<string>;
  startIndex: number;
  isOpen: boolean;
  handleCloseBtn: () => void;
}

export const LightBox: React.VFC<ILightBox> = ({ startIndex, images, isOpen, handleCloseBtn }) => {
  const [currentImage, setCurrentImage] = useState(1);

  useCloseOnEsc(handleCloseBtn);

  const modalRef = useTrapFocus({
    focusOnRender: true,
    returnFocus: true,
  });

  return isOpen ? (
    <ModalPortal id="lightbox-modal-portal">
      <div
        className={`${styles.lightbox} ${currentImage === 1 ? styles['lightbox--first'] : ''} ${
          currentImage === images.length ? styles['lightbox--last'] : ''
        }`}
        ref={modalRef}
      >
        <Splide
          className={styles.splide}
          options={{
            arrows: true,
            // TODO add custom arrow with svg path here
            // arrowPath:
            autoWidth: false,
            pagination: false,
            perPage: 1,
            gap: '1rem',
            classes: {
              arrows: 'lightbox__arrows',
              arrow: 'lightbox__arrow',
              prev: 'lightbox__arrow--prev',
              next: 'lightbox__arrow--next',
            },
            start: startIndex,
          }}
          aria-label="Articles"
          onActive={(slide) => setCurrentImage(slide.index + 1)}
        >
          {images.map((image, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SplideSlide className={styles['image-wrapper']} key={image + index}>
              <div className={styles['image-inner-wrapper']}>
                <Image
                  src={image}
                  layout="fill"
                  objectFit="contain"
                  loading={index + 1 <= currentImage + 2 ? 'eager' : 'lazy'}
                />
              </div>
            </SplideSlide>
          ))}
        </Splide>
        <button className={styles['close-btn']} type="button" onClick={handleCloseBtn}>
          <Icon icon={close} size={11} color={Colors.White} />
        </button>
        <div className={styles['index-wrapper']}>{`${currentImage}/${images.length}`}</div>
      </div>
    </ModalPortal>
  ) : null;
};

export default LightBox;
